var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-container"},[_c('SideBar'),_c('div',{staticClass:"screen"},[_c('AnalyticDash')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }